module.exports = __webpack_public_path__ + "static/media/montnets-g.logo-l.3965ac45.png";